/**
 * Created by Andrey Popov on 30.10.2024
 */

cc.HighlightUnit = function (unit, options) {
    cc.CallFunc.prototype.constructor.call(this, (target) => {
        target.highlighter = new UnitHighlighter(target, unit, options);
    });
};

cc.HighlightUnit.prototype = Object.assign(Object.create(cc.CallFunc.prototype), {
    constructor: cc.HighlightUnit
});